import { JSONable } from '@irian-ro/abstract-resource';
import { Maybe } from '@irian-ro/util-functions';

export class AbstractContactVO extends JSONable {
  uuid: string | undefined = undefined;
  contactName: string | undefined = undefined;
  phoneNumber: string | undefined = undefined;
  email: string | undefined = undefined;
  companyName: string | undefined = undefined;
  companyUuid: string | undefined = undefined;
  preferredLanguage = '';
  platformContact: Maybe<null> | undefined = undefined;
  deleted: boolean | undefined = undefined;

  constructor(uuid: string, contactName: string, email: string, companyName: string, companyUuid: string) {
    super();
    this.uuid = uuid;
    this.contactName = contactName;
    this.email = email;
    this.companyName = companyName;
    this.companyUuid = companyUuid;
  }
}
